import analyticsTracking from "./analytics-tracking";

class VideoHero {
  element = undefined;
  constructor(element) {
    if (!element) return;

    this.element = element;
    this.playButton = element.querySelector(".hero-video-play-button");
    this.posterImage = element.querySelector(".hero-video-player-poster");
    this.videoPlayer = element.querySelector(".hero-video-player");
    this.hideElementsOnPlay = element.querySelectorAll(
      "[data-hide-on-play-video]"
    );
    this.videoPlayer.style.display = "none";
    this.currentVideoTitle = document.title;
    this.originalVideoPlayerElement = this.videoPlayer.cloneNode(true);

    this.init();
  }

  init() {
    this.playButton.addEventListener(
      "click",
      function() {
        this.playVideo();

        analyticsTracking.sendEvent(
          "hero video",
          "click",
          "play video button",
          document.title,
          false
        );
      }.bind(this),
      false
    );
  }

  playVideo() {
    this.initPlayer(this.videoPlayer);
    this.hidePoster();
  }

  hidePoster() {
    this.hideElementsOnPlay.forEach(element => {
      element.style.display = "none";
    });
  }

  showPoster() {
    this.hideElementsOnPlay.forEach(element => {
      element.style.display = "block";
    });
  }

  destroyVideoPlayer(player) {
    player.remove();
    this.showPoster();
    this.element.appendChild(this.originalVideoPlayerElement);
    this.videoPlayer = this.element.querySelector(".hero-video-player");
  }

  initPlayer(element) {
    this.videoPlayer.style.display = "block";
    const listValue = this.getYoutubeListID(element);
    this.resetVideoProgressTrack();

    const player = new MediaElement(element, {
      showPosterWhenPaused: true,
      youtube: {
        imageQuality: "maxresdefault",
        showPosterWhenEnded: true,
        nocookie: true,
        controls: false,
        loop: 0,
        showinfo: 0,
        modestbranding: 1,
        disablekb: 0,
        autoplay: 1,
        list: listValue
      },
      showPosterWhenEnded: true,
      iPadUseNativeControls: true,
      iPhoneUseNativeControls: true,
      AndroidUseNativeControls: true,
      stretching: "responsive",
      features: ["progress"]
    });

    this.registerEvents(player, !listValue);

    return player;
  }

  registerEvents(player, showPosterAtTheEndOfTheVideo) {
    player.addEventListener(
      "play",
      function(event) {
        this.sendGTMEvent(event);
      }.bind(this)
    );
    player.addEventListener(
      "pause",
      function(event) {
        this.sendGTMEvent(event);
      }.bind(this)
    );
    player.addEventListener(
      "ended",
      function(event) {
        this.sendGTMEvent(event);
        this.resetVideoProgressTrack();
        if (showPosterAtTheEndOfTheVideo) this.destroyVideoPlayer(player);
      }.bind(this)
    );

    player.addEventListener(
      "timeupdate",
      function(event) {
        this.sendGTMEventVideoProgress(player);
      }.bind(this)
    );

    player.addEventListener(
      "loadedmetadata",
      function(event) {
        this.setCurrentVideoTitle(player);
        this.resetVideoProgressTrack();
      }.bind(this)
    );
  }

  sendGTMEventVideoProgress(player) {
    const watchedRatio = Math.round(
      (player.currentTime * 100) / player.duration
    );

    const steps = [25, 50, 75, 100];
    steps.forEach(step => {
      if (watchedRatio == step && this.currentProgressStep < step) {
        this.currentProgressStep = step;

        analyticsTracking.sendEvent(
          "hero video",
          `${step}% Watched`,
          this.currentVideoTitle,
          step,
          true
        );
      }
    });
  }

  resetVideoProgressTrack() {
    this.currentProgressStep = 0;
  }

  setCurrentVideoTitle(player) {
    if (player.youTubeApi)
      this.currentVideoTitle = player.youTubeApi.getVideoData().title;
  }

  sendGTMEvent(event) {
    analyticsTracking.sendEvent(
      "hero video",
      event.type,
      this.currentVideoTitle,
      1,
      false
    );
  }

  getYoutubeListID(element) {
    const sources = element.getElementsByTagName("source");
    let videoUrl = element.getAttribute("src");

    if (sources.length) {
      videoUrl = sources[0].getAttribute("src");
    }

    if (videoUrl) {
      const match = videoUrl.match(/list=([^&]*)/);
      if (match && match.length > 1) return match[1]; //extract ?list=LIST_ID
    }

    return undefined;
  }
}
export default VideoHero;
